import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { claimMysteryBox } from "@/helper/contractFunctions/MafiaStoryMode";

export interface MysteryBoxState {
  isClaimingMysteryBox: boolean;
}

const initialState: MysteryBoxState = {
  isClaimingMysteryBox: false,
};

export const openMysteryBoxAction = createAsyncThunk(
  "mysteryBox/openMysteryBoxAction",
  async ({ account, itemId }: { account: string; itemId: number }) =>
    (await claimMysteryBox(account, itemId)).transactionHash
);

const mysteryBoxSlice = createSlice({
  name: "mysteryBox",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(openMysteryBoxAction.pending, (state) => {
        state.isClaimingMysteryBox = true;
      })
      .addCase(openMysteryBoxAction.fulfilled, (state) => {
        state.isClaimingMysteryBox = false;
      })
      .addCase(openMysteryBoxAction.rejected, (state, { error }) => {
        state.isClaimingMysteryBox = false;
        console.log(error.message);
      });
  },
});

export default mysteryBoxSlice.reducer;
